import $ from 'jquery';
import { Dispatcher } from 'barba.js';
import { addMetadataHook } from '../pjax';

// export default function headerSection() {
// 	const $html = $('html');
// 	const $scroller = $('html, body');

// 	const $header = $('#header');
// 	const $headerNav = $('#header-nav');
// 	const headerToggler = $headerNav.data('toggler');

// 	if (headerToggler) {

// 		headerToggler.on('toggle', function() {
// 			$html.toggleClass('is-header-open', headerToggler.isOpen);

// 			if (headerToggler.isOpen) {
// 				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
// 			}
// 		});
// 	}
// }

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');

	const $overlay = $('#overlay');

	const toggler = $headerNav.data('toggler');
	const togglerClass = $header.data('toggler-class');


	if (toggler) {

		toggler.on('toggle', function() {
			$html.toggleClass('is-header-open', toggler.isOpen);

			if (toggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});
	}

	Dispatcher.on('initStateChange', function({ url }) {
		const $navLinks = $headerNav.find('a');

		// Give it some time before closing to improve UX
		setTimeout(() => toggler.close(), 200);

		$navLinks.removeClass('is-uri is-descendant-uri');
		$navLinks.filter(`[href="${url}"]`).addClass('is-uri');
		// TODO Descendant URI classes should be added... but it's a lot of work for something that would go unnoticed.
	});

	addMetadataHook('headerContext', {
		init(value) {
			$header.removeClass(togglerClass);

			if(value) {
				$header.addClass('-overlay');
			} else {
				$header.removeClass('-overlay');
			}
			$header.addClass(togglerClass);
		},

		destroy(value) {
			// Destroy
		},
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js